interface result {
  [key: string]: any;
}

export const toCamelCase = (str: string): string => {
  return str
    .split('_')
    .map(function (word, index) {
      if (index === 0) {
        return word.toLowerCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join('');
};

export const toCamelCaseObject = (obj: any): Record<string, any> => {
  const result = {} as result;
  Object.keys(obj).forEach((key: string) => {
    result[toCamelCase(key)] = obj[key];
  });
  return result;
};

const toUnderscoreCase = (str: string): string => {
  return str
    .split(/(?=[A-Z])/)
    .join('_')
    .toLowerCase();
};

export const toUnderscoreCaseObject = (obj: any): Record<string, any> => {
  const result = {} as result;
  Object.keys(obj).forEach((key) => {
    result[toUnderscoreCase(key)] = obj[key];
  });
  return result;
};

export const formDataMapper = (
  formData: FormData,
  params: any,
  key = ''
): void => {
  for (const k in params) {
    const v = params[k];
    const uk =
      key === '' ? toUnderscoreCase(k) : key + '[' + toUnderscoreCase(k) + ']';
    if (typeof v === 'object') {
      formDataMapper(formData, v, uk);
    } else {
      if (v === undefined || v === null) continue;
      formData.append(uk, v);
    }
  }
};

export const getDataMapper = (sendData: any, params: any, key = ''): void => {
  for (const k in params) {
    const v = params[k];
    const uk =
      key === '' ? toUnderscoreCase(k) : key + '[' + toUnderscoreCase(k) + ']';
    if (typeof v === 'object') {
      getDataMapper(sendData, v, uk);
    } else {
      if (v === undefined || v === null) continue;
      sendData[uk] = v;
    }
  }
};
